/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Compare_Event_Groups_Event_Group_A_LabelInputs */

const en_compare_event_groups_event_group_a_label = /** @type {(inputs: Compare_Event_Groups_Event_Group_A_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Event Group A:`)
};

const fr_compare_event_groups_event_group_a_label = /** @type {(inputs: Compare_Event_Groups_Event_Group_A_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Groupe d'événements A :`)
};

const de_compare_event_groups_event_group_a_label = /** @type {(inputs: Compare_Event_Groups_Event_Group_A_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Veranstaltungsgruppe A:`)
};

const it_compare_event_groups_event_group_a_label = /** @type {(inputs: Compare_Event_Groups_Event_Group_A_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Gruppo di eventi A:`)
};

const ru_compare_event_groups_event_group_a_label = /** @type {(inputs: Compare_Event_Groups_Event_Group_A_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Группа мероприятий А:`)
};

const es_compare_event_groups_event_group_a_label = /** @type {(inputs: Compare_Event_Groups_Event_Group_A_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Grupo de eventos A:`)
};

const zh_cn2_compare_event_groups_event_group_a_label = /** @type {(inputs: Compare_Event_Groups_Event_Group_A_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`活动组A：`)
};

const ja_compare_event_groups_event_group_a_label = /** @type {(inputs: Compare_Event_Groups_Event_Group_A_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`イベントグループA:`)
};

const hi_compare_event_groups_event_group_a_label = /** @type {(inputs: Compare_Event_Groups_Event_Group_A_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`इवेंट ग्रुप ए:`)
};

const pt_pt2_compare_event_groups_event_group_a_label = /** @type {(inputs: Compare_Event_Groups_Event_Group_A_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Grupo de Eventos A:`)
};

/**
* | output |
* | --- |
* | "Event Group A:" |
*
* @param {Compare_Event_Groups_Event_Group_A_LabelInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const compare_event_groups_event_group_a_label = /** @type {((inputs?: Compare_Event_Groups_Event_Group_A_LabelInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Compare_Event_Groups_Event_Group_A_LabelInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_compare_event_groups_event_group_a_label(inputs)
	if (locale === "de") return de_compare_event_groups_event_group_a_label(inputs)
	if (locale === "it") return it_compare_event_groups_event_group_a_label(inputs)
	if (locale === "ru") return ru_compare_event_groups_event_group_a_label(inputs)
	if (locale === "es") return es_compare_event_groups_event_group_a_label(inputs)
	if (locale === "zh-CN") return zh_cn2_compare_event_groups_event_group_a_label(inputs)
	if (locale === "ja") return ja_compare_event_groups_event_group_a_label(inputs)
	if (locale === "hi") return hi_compare_event_groups_event_group_a_label(inputs)
	if (locale === "pt-PT") return pt_pt2_compare_event_groups_event_group_a_label(inputs)
	return en_compare_event_groups_event_group_a_label(inputs)
});